module.exports = __webpack_public_path__ + "static/media/edit.ea64341a.svg";